/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/role_permissions-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/role_permissions-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 * - Or run: npm run db:full-workflow (does everything)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/role_permissions-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-role_permissions-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/role_permissions.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Generated at: 2026-06-22T23:44:13.685Z
 * Source config: config/entities/role_permissions-entity-config.ts
 * Public fields: 8/8 total fields
 */

import { Type, Static } from "@sinclair/typebox";

// TypeBox schemas for runtime validation (public fields only)
export const RolePermissionsSchema = Type.Object({
  id: Type.String({ format: "uuid" }), // id field
  role_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // role_id field
  permission_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // permission_id field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  trig_role_name: Type.Union([Type.String(), Type.Null()]), // trig_role_name field
  trig_role_description: Type.Union([Type.String(), Type.Null()]), // trig_role_description field
  trig_permission_name: Type.Union([Type.String(), Type.Null()]), // trig_permission_name field
});

export const CreateRolePermissionsSchema = Type.Object({
  role_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // role_id field
  permission_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // permission_id field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  trig_role_name: Type.Union([Type.String(), Type.Null()]), // trig_role_name field
  trig_role_description: Type.Union([Type.String(), Type.Null()]), // trig_role_description field
  trig_permission_name: Type.Union([Type.String(), Type.Null()]), // trig_permission_name field
});

export const UpdateRolePermissionsSchema = Type.Object({
  role_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // role_id field
  permission_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // permission_id field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  trig_role_name: Type.Union([Type.String(), Type.Null()]), // trig_role_name field
  trig_role_description: Type.Union([Type.String(), Type.Null()]), // trig_role_description field
  trig_permission_name: Type.Union([Type.String(), Type.Null()]), // trig_permission_name field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type RolePermissionsRow = Static<typeof RolePermissionsSchema>;
export type RolePermissionsInsert = Static<typeof CreateRolePermissionsSchema>;
export type RolePermissionsUpdate = Static<typeof UpdateRolePermissionsSchema>;

// Legacy type aliases for backward compatibility
export type RolePermissions = RolePermissionsRow;
export type CreateRolePermissions = RolePermissionsInsert;
export type UpdateRolePermissions = Static<typeof UpdateRolePermissionsSchema>;

// Field configuration metadata
export const RolePermissionsFieldConfig = {
  filterable: ["id", "role_id", "permission_id"] as const,
  sortable: ["created_at"] as const,
  searchable: [] as const,
  required: ["id"] as const,
  readonly: ["id", "created_at"] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from "../../../../../config/search/global-search-config.js";

export interface RolePermissionsQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface RolePermissionsResponse {
  data: RolePermissions[] | null;
  error: Error | null;
  count?: number;
}

export interface SingleRolePermissionsResponse {
  data: RolePermissions | null;
  error: Error | null;
}
